(() => {
  function getStrings() {
    const strings = window.cartDiscountStrings || {};
    return {
      MSG_NO_CODE: strings.errorNoCode || "Please enter a discount code.",
      MSG_ALREADY_APPLIED: strings.errorAlreadyApplied || "That discount code is already applied.",
      MSG_INVALID: strings.errorInvalid || "Discount code is invalid or not applicable.",
    };
  }

  function clearMessages() {
    const errDiv = document.getElementById('discount-error-message');
    if (errDiv) {
      errDiv.style.display = 'none';
      errDiv.textContent = '';
    }
  }

  function showError(msg) {
    const errDiv = document.getElementById('discount-error-message');
    if (errDiv) {
      errDiv.style.display = 'block';
      errDiv.textContent = msg;
    }
  }

  function getCurrentDiscounts() {
    const pills = document.querySelectorAll('#applied-discounts .discount-pill');
    return Array.from(pills).map((pill) => pill.getAttribute('data-code').toUpperCase());
  }

  function triggerCartUpdate() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
      const qtyInput =
        document.getElementById('Drawer-quantity-1') ||
        document.getElementById('Quantity-1');
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value, 10) || 1;
        cartDrawerItems.updateQuantity(1, currentQty);
        return;
      } else {
        cartDrawerItems.onCartUpdate();
        return;
      }
    }

    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      const qtyInput =
        document.getElementById('Quantity-1') ||
        document.getElementById('Drawer-quantity-1');
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value, 10) || 1;
        cartItems.updateQuantity(1, currentQty);
        return;
      } else {
        cartItems.onCartUpdate();
        return;
      }
    }
  }

  async function applyDiscounts(discountCodes = []) {
    let isRemoving = false;
    if (discountCodes.length === 0) {
      discountCodes = ['REMOVE_SHOPIFY_CODE'];
      isRemoving = true;
    }
    const discountString = discountCodes.join(',');
    const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountString)}`;

    try {
      await fetch(checkoutUrl, { method: 'GET' });
    } catch (err) {}

    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    const validSet = new Set();
    (cartData.cart_level_discount_applications || []).forEach(d => validSet.add(d.title.toUpperCase()));
    cartData.items.forEach(item => {
      (item.line_level_discount_allocations || []).forEach(a => {
        validSet.add(a.discount_application.title.toUpperCase());
      });
    });

    const invalidCodes = discountCodes.filter(c => !validSet.has(c.toUpperCase()));
    const newlyAddedCode = discountCodes[discountCodes.length - 1];
    const codeIsInvalid = invalidCodes.includes(newlyAddedCode);

    if (newlyAddedCode === 'REMOVE_SHOPIFY_CODE' || !codeIsInvalid) {
      triggerCartUpdate();
    }
    return {
      success: !codeIsInvalid || isRemoving,
      invalidCodes
    };
  }

  // Event delegation on `document`, bound once for the lifetime of the page,
  // instead of attaching listeners directly to #apply-discount-btn /
  // #applied-discounts and re-attaching them on every cart-update pub/sub
  // event. The cart drawer's contents get replaced (innerHTML swapped or
  // the element itself replaced) by several different code paths in the
  // theme - adding an item, changing quantity, removing an item - and not
  // all of them re-publish "cart-update" at the right time (product-form.js's
  // add-to-cart flow, for example, publishes cart-update *before* replacing
  // the drawer's HTML, so re-attaching listeners at that point immediately
  // becomes stale once the real DOM swap happens right after). Delegating
  // from `document` - which is never destroyed or replaced - means the
  // Apply/Remove buttons keep working regardless of how or when the drawer
  // markup underneath them gets regenerated.
  document.addEventListener('click', async (event) => {
    const applyBtn = event.target.closest('#apply-discount-btn');
    if (applyBtn) {
      const discountInput = document.getElementById('discount-input');
      if (!discountInput) return;
      const { MSG_NO_CODE, MSG_ALREADY_APPLIED, MSG_INVALID } = getStrings();
      clearMessages();
      const existingCodes = getCurrentDiscounts();
      let newCode = discountInput.value.trim().toUpperCase();
      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }
      if (existingCodes.includes(newCode)) {
        showError(MSG_ALREADY_APPLIED);
        return;
      }
      const combinedCodes = [...existingCodes, newCode];
      const result = await applyDiscounts(combinedCodes);
      if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
        showError(MSG_INVALID);
      }
      return;
    }

    const removeBtn = event.target.closest('#applied-discounts .remove-discount');
    if (removeBtn) {
      clearMessages();
      const pill = removeBtn.closest('.discount-pill');
      if (!pill) return;
      const codeToRemove = pill.getAttribute('data-code');
      if (!codeToRemove) return;
      const existingCodes = getCurrentDiscounts();
      const newDiscountList = existingCodes.filter((c) => c !== codeToRemove.toUpperCase());
      await applyDiscounts(newDiscountList);
    }
  });
})();
